import { deleteType } from "actions/Utilities/BusinessLicensesPermitsType";
import { toast } from "components/toastNotification";
import React from "react";
import { useMutation } from "react-query";

export default function useDeleteType() {
  const { mutate } = useMutation((ids: number[]) => deleteType(ids), {
    onSuccess: (res: any) => {
      switch (true) {
        case res == "Success":
          toast.fire(
            "Success",
            "Business License Permit Type Disabled Successfully",
            "success"
          );
          break;
        case res.includes("Notification insert Failed"):
          toast.fire(
            "Success ",
            `Business License Permit Type Disabled Successfully, BUT ${res}`,
            "warning"
          );
          break;
        case res == "Operation Failed!":
          toast.fire(
            "Disabling Business License Permit Type failed ",
            `Server Error: ${res}`,
            "error"
          );
          break;
        case res == "Business License Permit Type not found":
          toast.fire(
            "Disabling Business License Permit Type failed ",
            `Error: ${res}`,
            "error"
          );
          break;
        default:
          toast.fire(
            "Disabling Business License Permit Type failed",
            res.Message,
            "error"
          );
      }
    },
    onError: (error) => {
      toast.fire(
        "Disabling Business License Permit Type failed",
        `Error: ${error}`,
        "error"
      );
    },
  });

  return mutate;
}
